const form = document.querySelector('#form');
let button = form.querySelector('button');
let checkBox = form.querySelector('[name="agreed"]');
checkBox.addEventListener('change', (event) => {
    if (checkBox.checked) {
        button.classList.remove('disabled');
    }
    else {
        button.classList.add('disabled');
    }
})

form.addEventListener('submit', function (e) {
    e.preventDefault();
    const body = Object.fromEntries(new FormData(e.target));
    if (body.firstName != undefined && body.lastName != undefined && body.email != undefined && body.source != undefined &&
        body.age18OrOlder != undefined && body.agreed != undefined && body.zipcode != undefined) {
        if (body.age18OrOlder == "yes") {
            form.querySelector('[data-age-error-msg]').classList.add('d-none');
            let updatedBody = {
                Action: "SendMessage",
                MessageBody: JSON.stringify(body)
            }
            let formBody = [];
            for (let property in updatedBody) {
                let encodedKey = encodeURIComponent(property);
                let encodedValue = encodeURIComponent(updatedBody[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
            try {
                fetch('https://sqs.us-east-1.amazonaws.com/758437162848/qALKPatientRegistration', {
                    method: 'POST', // Specify the HTTP method
                    body: formBody, // Collect form data
                    headers: {
                        'Content-type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(response => response.text()) // Read response as text
                    .then(data => {
                        let formEl = document.getElementById('form');
                        if (formEl) formEl.classList.add('d-none');

                        let successMessageEl = document.getElementById('success_message');
                        if (successMessageEl) successMessageEl.classList.remove('d-none');
                    }) // Alert the response 
            }
            catch (error) { alert('An error occurred!'); }
        }
        else {
            form.querySelector('[data-age-error-msg]').classList.remove('d-none');
        }
    }
});